import {Observable, throwError} from 'rxjs';
import {ICampaignActiveScheduled, ICampaignFullInfo, ICampaignHistory, ICampaignSaved} from '@interfaces/advertiser/campaign';
import {createHttpParams} from '@shared/functions';
import {catchError, share} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {ErrorService} from '@services/error/error.service';
import {Injectable} from '@angular/core';
import {IResponse} from '@interfaces/response';
import {CampaignsSortType} from '../../types/campaigns.type';
import {OrderType} from '../../types/order.type';
import {AdvertiserCampaignEnum} from '@shared/enums/advertiser-campaign.enum';


@Injectable({
  providedIn: 'root'
})
export class AdvertiserCampaignService {
  constructor(private http: HttpClient,
              private errorService: ErrorService) {
  }

  public getAdvertiserCampaigns(
    type: AdvertiserCampaignEnum, {limit, skip = 0, search, sort, order}:
      {
        limit: number, skip: number, search: string,
        sort: CampaignsSortType;
        order: OrderType;
      }
  ): Observable<IResponse<ICampaignSaved | ICampaignActiveScheduled | ICampaignHistory>> {
    const params = createHttpParams({
      limit, skip, sort, order, search
    });

    return this.http.get<IResponse<ICampaignSaved | ICampaignActiveScheduled | ICampaignHistory>>
    (`advertizer/campaigns/${type}`, {params}).pipe(
      share(),
      catchError((err) => {
        this.errorService.showError(err);
        return throwError(err);
      })
    );
  }

  public getAdvertiserCampaignById(id: number): Observable<ICampaignFullInfo> {
    return this.http.get<ICampaignFullInfo>(`advertizer/campaigns/${id}`).pipe(
      catchError((err) => {
        this.errorService.showError(err);
        return throwError(err);
      })
    );
  }

  public postAdvertiserCampaign(
    {name, submitted, start, finish, mediaId, devices}
      : {
      name: string, submitted: boolean, start: string, finish: string, mediaId: number, devices: number[]
    }): Observable<ICampaignFullInfo> {
    return this.http.post<ICampaignFullInfo>('advertizer/campaigns', {name, submitted, start, finish, mediaId, devices})
      .pipe(
        catchError((err) => {
          this.errorService.showError(err, false);
          return throwError(err);
        })
      );
  }

  public updateAdvertiserCampaign(
    {name, submitted, start, finish, mediaId, devices, id}: {
      id: number, name: string, submitted: boolean, start: string, finish: string,
      mediaId: number, devices: { toAdd: number[], toRemove: number[] }
    }): Observable<ICampaignFullInfo> {
    return this.http.patch<ICampaignFullInfo>('advertizer/campaigns', {name, submitted, start, finish, mediaId, devices, id})
      .pipe(
        catchError((err) => {
          this.errorService.showError(err, false);
          return throwError(err);
        })
      );
  }
}
